import { Component, Input, OnInit } from '@angular/core';
import { CacheKey } from '../../../shared/constants/cachekey.constants';
import { State } from '../../../shared/interface/state.interface';
import { CacheService } from '../../../shared/services/cache.service';
import { EnrollmentCommonService } from '../../../shared/services/enrollment-common.service';
import { PurchaseFlow } from '../../common/enumerations';
import { PaymentConstants } from '../../constants/payment.constants';
import { MemberTypeEnum } from '../../enums/member-type.enum';
import { OrderSourceTypes, OrderSourceValue } from '../../enums/order-source.enum';
import { PaymentProcessorAlias } from '../../enums/payment-processor-alias.enum';
import { PaymentStatus } from '../../enums/payment-status.enum';
import { PosPaymentGroupEnum } from '../../enums/pos-payment-group.enum';
import { Address } from '../../interface/address';
import { ECheckAddress } from '../../interface/eCheck/eCheckAddress.interface';
import { PaymentCallBackUrl } from '../../interface/payvision/payment-callback-url.interface';
import { WorldpayXMLPaymentService } from '../../interface/worldpay-xml/worldpay-xml-payment-service.interface';
import { WorldpayXMLRegistration } from '../../interface/worldpay-xml/worldpay-xml-registration.interface';
import { PaymentComponentSettings } from '../../models/payments/payment.model';
import { CustomerService } from '../../services/customer.service';
import { WorldpayXMLService } from '../../services/worldpay-xml.service';
import { DeliveryPreference} from '../../common/enumerations';
import { parseJsonText } from 'typescript';

declare let WPCL: any;

@Component({
    selector: 'payment-worldpay-xml',
    templateUrl: '../../templates/template1/views/payments/worldpay-xml.component.html',
    styleUrls: []
})

export class WorldPayXMLComponent implements OnInit {
    states: any[] = [];
    @Input() paymentComponentSettings: PaymentComponentSettings;
    @Input() setPickupAddress:Address;
    @Input() setShippingAddress:Address;
    @Input() orderType: number;
    @Input() deliveryPreferenceType:any;
    deliveryPreference = DeliveryPreference;
    posPaymentGroupEnum = PosPaymentGroupEnum;
    countries: any;
    constructor(
        private _customerService: CustomerService,
        private _worldpayXMLService: WorldpayXMLService,
        private _cacheService: CacheService,
        private _enrollmentCommonService: EnrollmentCommonService,
        ) { }

    ngOnInit(): void {
        this.getAllCountriesInfo();
        this.getStates();
    }

    /**
 * get States
 */
    getStates() {
        this._customerService.getStates().subscribe(response => {
            if (response) {
                this.states = response;
                this.getWorldplayXMLPaymentForm();
            } else {
                this.getWorldplayXMLPaymentForm();
            }
        }, (error: any) => {
            this.getWorldplayXMLPaymentForm();
        });
    }

    /**
    * @description to get the Payment form
    * @date 2018-07-27
    * @memberof WorldPayComponent
    */
    getWorldplayXMLPaymentForm(): void {
        this._worldpayXMLService
            .getWorldpayXMLForm(this.paymentComponentSettings.storeId, this.getWorldpayXMLRegistrationRequest())
            .subscribe((response) => {
                this.loadWorldplayXMLForm(response);
            });
    }

    /**
    * @description to load the Worldplay XML
    * Registration Checkout form
    * @date 2018-07-27
    * @memberof WorldPayComponent
    */
    loadWorldplayXMLForm(registrationResponse): void {
        if (WPCL && registrationResponse && registrationResponse.paymentUrl) {
            const customOptions = {
                iframeHelperURL: window.location.href,
                iframeBaseURL: window.location.origin,
                iframeIntegrationID: 'ifr',
                url: registrationResponse.paymentUrl,
                target: 'iframeRes',
                type: 'iframe',
                inject: 'immediate',
            };
            const libraryObject = new WPCL.Library();
            if (libraryObject) {
                libraryObject.setup(customOptions);
            }
        }
    }

    /**
     * @description preparing the WorldPay XML Registration
     * checkout form request
     * @date 2018-07-27
     * @returns {WorldpayXMLRegistration}
     * @memberof WorldPayComponent
     */
    getWorldpayXMLRegistrationRequest(): WorldpayXMLRegistration {
        var orderSession = sessionStorage.getItem(CacheKey.OrderInfo) ? JSON.parse(sessionStorage.getItem(CacheKey.OrderInfo)) : sessionStorage.getItem(CacheKey.OrderInfo) ? JSON.parse(sessionStorage.getItem(CacheKey.OrderInfo)) : null;
        var orderType:number;
        if(orderSession){
            orderType = orderSession.orderType;
        }
        else if(this.orderType){
            orderType = this.orderType;
        }
        const worldpayXMLRegistration: WorldpayXMLRegistration = {
            portalCsp: true,
            countryCode: this.paymentComponentSettings.isoCountryCode.toUpperCase(),
            customerId: this.paymentComponentSettings.memberId ? (+this.paymentComponentSettings.memberId) : 0,
            storeId: this.paymentComponentSettings.storeId,   
            orderTypeId: (this.paymentComponentSettings.webOrderId && this.paymentComponentSettings.orderType === OrderSourceTypes.POS)?
                this.getOrderTypeId():this.paymentComponentSettings.orderTypeId ? this.paymentComponentSettings.orderTypeId
                : PurchaseFlow.Personal_Order,
            orderSourceTypeId: (this.paymentComponentSettings.webOrderId && this.paymentComponentSettings.orderType === OrderSourceTypes.POS)?
                                      OrderSourceValue.POS : OrderSourceValue.CUSTOMER,
            paymentMethodType: this.paymentComponentSettings.paymentMethodTypes.Credit_Card,
            currencyCode: this.paymentComponentSettings.currencyCode,
            orderReferenceId: this.paymentComponentSettings.webOrderId ? this.paymentComponentSettings.orderReferenceId:null,
            paymentGroupId: this.paymentComponentSettings.webOrderId?this.posPaymentGroupEnum.Integrated_Payments:null,
            paymentRequestModel: {
                createRegistartion: true,
                 webOrderId: (this.paymentComponentSettings.webOrderId && this.paymentComponentSettings.orderType=== OrderSourceTypes.POS) ?
                                            this.paymentComponentSettings.webOrderId:null
            },
            billingAddress: this.getBillingAddress(),
            paymentCallBackUrlModel: this.getPaymentCallBackURLModel(),
            paymentServiceModel: this.getPaymentServiceModel(),
            memberTypeId: this._enrollmentCommonService.getMemberTypeId(orderType),
            shippingAddress: this.getShippingAddress()
        };
        return worldpayXMLRegistration;
    }
    getShippingAddress(): Address {
       var orderSession = sessionStorage.getItem(CacheKey.OrderInfo) ? JSON.parse(sessionStorage.getItem(CacheKey.OrderInfo)) : sessionStorage.getItem(CacheKey.OrderInfo) ? JSON.parse(sessionStorage.getItem(CacheKey.OrderInfo)) : null;
       var shippinginformation = null;
       if(this.deliveryPreferenceType === this.deliveryPreference.DELIVERY) {
            if(orderSession) {
                shippinginformation = orderSession.shippingAddressInfo || orderSession.mailingAddress || orderSession.pudoaddress;
            }
            else if(this.setShippingAddress) {
                shippinginformation = this.setShippingAddress;
            }
    }else if( this.deliveryPreferenceType === this.deliveryPreference.PICKUP){
        shippinginformation = this.setPickupAddress;
       
    }
        if (shippinginformation) {
            const country = this.countries.find(x => x.isocodeThree.toLowerCase()
        === shippinginformation.countryCode.toLowerCase());
            const shippingAddress: Address = {
                country: country ? country.isocodeThree : '',
                countryCodeTwo: country ? country.isocodeTwo : '',
                countryCode: country ? country.isocodeThree : '',
                state: shippinginformation.stateCode,
                city: shippinginformation && shippinginformation.city ? shippinginformation.city : '',
                postalCode: shippinginformation ? shippinginformation.postalCode : '',
                addressLine1: shippinginformation && shippinginformation.addressLine1 ? shippinginformation.addressLine1 : '',
                addressLine2: shippinginformation && shippinginformation.addressLine2 ? shippinginformation.addressLine2 : '',
                addressLine3: shippinginformation && shippinginformation.addressLine3 ? shippinginformation.addressLine3 : '',
            };
            return shippingAddress;
        }
    }
    getAllCountriesInfo() {
        this._customerService.getAllCountries(true).subscribe(response => {
            if (response) {
                this.countries = response;
            }
        });
    }
    /**
     * @description this method will return payment call urls
     * @date 2018-08-22
     * @private
     * @returns {PaymentCallBackUrl}
     * @memberof WorldPayXMLComponent
     */
    private getPaymentCallBackURLModel(): PaymentCallBackUrl {
        const paymentCallBackUrlModel: PaymentCallBackUrl = {
            webOrderId:(this.paymentComponentSettings.webOrderId && this.paymentComponentSettings.orderType === OrderSourceTypes.POS)?
                              this.paymentComponentSettings.webOrderId :null,
            cancelledUrl: this.getCurrentWindowUrl() + PaymentStatus.CANCELLED.toLowerCase(),
            failureUrl: this.getCurrentWindowUrl() + PaymentStatus.FAILED.toLowerCase(),
            successUrl: this.getCurrentWindowUrl() + PaymentStatus.SUCCESS.toLowerCase(),
            orderSourceTypeId: (this.paymentComponentSettings.webOrderId && this.paymentComponentSettings.orderType === OrderSourceTypes.POS)?
                                         OrderSourceValue.POS : OrderSourceValue.CUSTOMER,
           
        };
        return paymentCallBackUrlModel;
    }


    getOrderTypeId(): number{
        if(this.paymentComponentSettings.memberTypeId && (this.paymentComponentSettings.memberTypeId ===MemberTypeEnum.DISTRIBUTOR || 
            this.paymentComponentSettings.memberTypeId ===MemberTypeEnum.FPC)){
                return PurchaseFlow.Personal_Order;
            }else{
                return PurchaseFlow.Retail;
            }
           
    }
    /**
     * @description this method will return world pay xml
     * request model
     * @date 2018-08-21
     * @private
     * @returns {WorldpayXMLPaymentService}
     * @memberof WorldPayXMLComponent
     */
    private getPaymentServiceModel(): WorldpayXMLPaymentService {
        const userEmail: string = this.paymentComponentSettings.memberEmail ? this.paymentComponentSettings.memberEmail : '';
        const paymentServiceModel: WorldpayXMLPaymentService = {
            submit: {
                order: {
                     orderCode: this.paymentComponentSettings.webOrderId?this.paymentComponentSettings.webOrderId:null,
                    description: PaymentProcessorAlias.WORLDPAYXML,
                    amount: {
                        currencyCode: this.paymentComponentSettings.currencyCode,
                        exponent: this.paymentComponentSettings.numberDecimals
                    },
                    paymentMethodMask: {
                        include: {
                            code: PaymentConstants.paymentMethodMaskCode
                        }
                    },
                    shopper: {
                        shopperEmailAddress: userEmail
                    }
                }
            }
        };
        return paymentServiceModel;
    }

    /**
     * @description this method will return current window url
     * @date 2018-08-13
     * @private
     * @returns {string}
     * @memberof WorldPayComponent
     */
    private getCurrentWindowUrl(): string {
        const routeURL = window.location.href.includes('posorders') ? '/customerservice/posorders/' : '/customerservice/orders/';
        const currentWindowURL: string = window.location.origin + routeURL
            + PaymentProcessorAlias.WORLDPAYXML.toLowerCase() + '/';
        return currentWindowURL;
    }

    /**
    * @description mapping the billing address in the
    * WorldPay XML payment form
    * @date 2018-07-27
    * @private
    * @returns {WorldPay XMLBillingAddress}
    * @memberof WorldPayComponent
    */
    private getBillingAddress(): ECheckAddress {
        const code = this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.countryCodeTwo 
                     ?  this.paymentComponentSettings.billingAddress.countryCodeTwo : '';
        const statesOfSelectedCountry = this.states.filter(x=> x.countryCode === this.paymentComponentSettings.isoCountryCode);
        const billingAddress: ECheckAddress = {
            countryCode: code ? code : (this.paymentComponentSettings.isoTwoletterCountryCode 
                ? this.paymentComponentSettings.isoTwoletterCountryCode : ''),
            countryCodeTwo: code ? code : (this.paymentComponentSettings.isoTwoletterCountryCode
                ? this.paymentComponentSettings.isoTwoletterCountryCode : ''),
            country: code ? code : (this.paymentComponentSettings.isoTwoletterCountryCode
                ? this.paymentComponentSettings.isoTwoletterCountryCode : ''),
            city: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.city)
                ? this.paymentComponentSettings.billingAddress.city.toString() : '',
            state: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.stateId)
                ? this.states.find(x => x.id === this.paymentComponentSettings.billingAddress.stateId).stateCode : statesOfSelectedCountry[0].stateCode,
            postalCode: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.zipCode)
                ? this.paymentComponentSettings.billingAddress.zipCode.toString() : '',
            addressLine1: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.addressLine1)
                ? this.paymentComponentSettings.billingAddress.addressLine1.toString() : '',
            addressLine2: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.addressLine2)
                ? this.paymentComponentSettings.billingAddress.addressLine2.toString() : '',
            addressLine3: (this.paymentComponentSettings.billingAddress && this.paymentComponentSettings.billingAddress.addressLine3)
                ? this.paymentComponentSettings.billingAddress.addressLine3.toString() : '',
        };
        return billingAddress;
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/payments/worldpay-xml.component.ts